import { render, staticRenderFns } from "./ManagerData.vue?vue&type=template&id=29b6b207&scoped=true&"
import script from "./ManagerData.vue?vue&type=script&lang=js&"
export * from "./ManagerData.vue?vue&type=script&lang=js&"
import style0 from "./ManagerData.vue?vue&type=style&index=0&id=29b6b207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b6b207",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
